module.exports = __webpack_public_path__ + "img/shell.83c35cd7.jpeg";